import { OrderFields } from "../orderTypes";
import PreviewFull from "./PreviewFull";
import PreviewNotification from "./PreviewNotification";
import { PreviewContainer, PreviewFullContainer } from "./styles";
import { ShiftDetailsType } from "./types";

type Props = {
  values: OrderFields;
  shiftDetails: ShiftDetailsType[];
  dates: Array<Date> | null;
};

const Preview = ({ values, shiftDetails, dates }: Props) => {
  return (
    <PreviewContainer>
      <PreviewNotification
        values={values}
        shiftDetails={shiftDetails}
        dates={dates}
      />
      <PreviewFullContainer>
        <PreviewFull values={values} shiftDetails={shiftDetails} />
      </PreviewFullContainer>
    </PreviewContainer>
  );
};

export default Preview;
